import accessibleSubmitButton from './accessible-submit-button';
import contactFormAppends from './contact-form-appends';
import sendTestForm from './send-test-form';
import contactFormsLazyLoad from './contact-forms-lazy-load';
import aiEnhancedForm from './ai-enhanced-form';

/**
 * @function init
 * @description Kick off this modules functions
 */

const init = () => {
	if (window.siteFeatureToggles && parseInt(siteFeatureToggles.ENABLE_AI_ENHANCED_FORM, 10)) {
		aiEnhancedForm();
	}

	accessibleSubmitButton();

	contactFormAppends();

	sendTestForm();

	contactFormsLazyLoad();
};

export default init;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/index.js